// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_foi","cls2":"CiterightLanding-cls2_cTm CiterightLanding-cls1_foi"};